import { ActionType } from '../actions/action'
import { FlowVersion } from '../flow-version'
import { Step } from '../util/flow-structure-util'
import { DragStepRequest } from './index'


export function _dragStep(flowVersion: FlowVersion, request: DragStepRequest): void {
    function updatePosition(step: Step): void {
        if (step.settings) {
            step.settings = {
                ...step.settings,
                position: {
                    x: request.newPosition.x,
                    y: request.newPosition.y,
                },
            }
        }
    }

    function findAndUpdateStep(steps: Step[]): boolean {
        for (const step of steps) {
            if (step.name === request.stepName) {
                updatePosition(step)
                return true
            }
            if (step.type === ActionType.LOOP_ON_ITEMS && step.subflow) {
                if (findAndUpdateStep(step.subflow.actions)) return true
            }
            else if (step.type === ActionType.ROUTER && step.children) {
                for (const child of step.children) {
                    if (child && findAndUpdateStep(child.actions)) return true
                }
            }
        }
        return false
    }

    if (!findAndUpdateStep(flowVersion.triggers) && !findAndUpdateStep(flowVersion.actions)) {
        throw new Error(`Step with name '${request.stepName}' not found in actions or triggers.`)
    }
}
